import activationMode from '@/helpers/rave/constants/activationModes'

export default {
  [activationMode.DESIGN]: 'Design',
  [activationMode.PERSONALITY]: 'Personality',
  [activationMode.MIXED]: 'mixed',
  [4]: 'Design View',
  [5]: 'Personality View',
}
